/* Fearless – pastilles couleur des cartes grip socks : un clic change la photo, le nom et les liens de la carte, sans quitter la page (16.10.2026) */
document.addEventListener('click', function (e) {
  var dot = e.target.closest('.fcc__dot[data-url]');
  if (!dot) return;
  e.preventDefault();
  var card = dot.closest('product-item');
  if (!card) return;
  var url = dot.getAttribute('data-url');
  card.querySelectorAll('.fcc__dot').forEach(function (d) { d.classList.toggle('is-on', d === dot); d.setAttribute('aria-pressed', d === dot ? 'true' : 'false'); });
  var img = card.querySelector('img.product-item__primary-image:not([hidden])');
  if (img) { img.removeAttribute('sizes'); img.srcset = dot.getAttribute('data-srcset'); img.src = dot.getAttribute('data-img'); img.sizes = '(max-width: 740px) 50vw, 25vw'; }
  var img2 = card.querySelector('img.product-item__secondary-image');
  if (img2) {
    var s2 = dot.getAttribute('data-img2');
    if (s2) { img2.srcset = s2; img2.style.display = ''; } else { img2.style.display = 'none'; }
  }
  var t = card.querySelector('.fcc__title');
  if (t) t.textContent = dot.getAttribute('data-title');
  card.querySelectorAll('a[href]').forEach(function (a) { if (!a.closest('.fcc__dots')) a.setAttribute('href', url); });
  card.querySelectorAll('quick-buy-popover[href], quick-buy-drawer[href]').forEach(function (q) {
    var v = (q.getAttribute('href').split('view=')[1] || '');
    q.setAttribute('href', url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=' + v);
    q.innerHTML = '';
  });
  card.setAttribute('data-fcc-url', url);
});
